export const APP_VERSION = '1.6.0 (7c06d4ae)';
export const GA_ID = 'undefined';